import { Col, Form, Input, Row, Space } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { SelectLeasingOperator, SelectLeasingProject, SelectYear } from "../../../../components/selects";
import { EntLeasingItem } from "../../../../models/mechanization/leasingItem";
import { EntLeasingRegister } from "../../../../models/mechanization/leasingRegister";
import { AddLeasingItems } from "./AddLeasingItems";

enum FormField {

    operatorId, // ID оператора
    projectId, // ID проекта
    issueDate, // Год выдачи лизинга
    count, // Количество техники
    financingAmount, // Сумма финансирования
    leaseTermYears, // Срок лизинга в годах
    interestRate, // Процентная ставка по лизингу
    territorialUnitId, // ID COATE
}

interface IProps {
    show: boolean;
    leasingRegister: EntLeasingRegister;
    onHide: () => void;
    onSubmit: (pos: EntLeasingRegister) => Promise<boolean>;
}

export const AddLeasingRegisterModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [items, setItems] = useState<EntLeasingItem[] | null>(null);

    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.operatorId, value: props.leasingRegister.operator?.id },
            { name: FormField.projectId, value: props.leasingRegister.project?.id },
            { name: FormField.issueDate, value: props.leasingRegister.issueDate },
            { name: FormField.leaseTermYears, value: props.leasingRegister.leaseTermYears },
            { name: FormField.interestRate, value: props.leasingRegister.interestRate },
        ]);
        if (props.leasingRegister.territorialUnits && props.leasingRegister.territorialUnits.length > 0) {
            setItems(props.leasingRegister.territorialUnits);
        }
    };
    const setEntityFromFields = (): EntLeasingRegister => {
        let res = _.cloneDeep(props.leasingRegister);
        res.operatorId = form.getFieldValue(FormField.operatorId);
        res.projectId = form.getFieldValue(FormField.projectId);
        res.issueDate = form.getFieldValue(FormField.issueDate);
        res.leaseTermYears = form.getFieldValue(FormField.leaseTermYears);
        res.interestRate = form.getFieldValue(FormField.interestRate);
        res.territorialUnits = items;
        return res;
    };
    const hideModal = () => {
        props.onHide();
        setItems(null)
    }
    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            if (!data.territorialUnits || data.territorialUnits.length === 0) {
                throw new Error("Список территориальных единиц не должен быть пустым!");
            }
            const invalidRegisters = data.territorialUnits!.filter(
                (register: any) => register.transportTypeId === null || register.count === null || register.financingAmount === null
            );
    
            if (invalidRegisters.length > 0) {
                throw new Error("У всех элементов транспорт и количество должны быть заполнены!");
            }
            const result = await props.onSubmit(data);
            if (result) hideModal();


        } finally {
            setLoading(false);
        }
    }

    
    return (
        <>
            <DraggableModal
                title={props.leasingRegister.id === null ? t('mechanisation.leasing.add_leasing') : t('mechanisation.leasing.edit_leasing')}
                visible={props.show}
                onCancel={() => { hideModal() }}
                onSubmit={handleSubmit}
                submitLoading={loading}
                width={800}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Row style={{ margin: 0 }} gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <Form.Item
                                label={t('mechanisation.leasing.project_leasing')}
                                name={FormField.projectId}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <SelectLeasingProject />
                            </Form.Item>

                            <Form.Item
                                label={t('mechanisation.leasing.operator_leasing')}
                                name={FormField.operatorId}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <SelectLeasingOperator />
                            </Form.Item>

                        </Col>
                        <Col className="gutter-row" span={12}>
                        <Space.Compact>
                        <Form.Item
                                label={t('mechanisation.leasing.leasing_agreement')}
                                name={FormField.issueDate}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <SelectYear />
                            </Form.Item>
                            <Form.Item
                                label={t('mechanisation.leasing.lease_term_in_years')}
                                name={FormField.leaseTermYears}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                        </Space.Compact>
                       
                            <Form.Item
                                label={t('mechanisation.leasing.leasing_interest_rate')}
                                name={FormField.interestRate}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <AddLeasingItems items={items}  setItems={setItems}/>
                </Form>
            </DraggableModal>
        </>
    );
};
